import apiClient from "./client";

export async function googleCallback(code) {
  const res = await apiClient.post("/api/google/callback", { code }, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Помилка Google авторизації");
  return data;
}

export async function login(email, password) {
  const res = await apiClient.post("/api/login", { email, password }, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Щось пішло не так");
  return data;
}

export async function register(formData) {
  const res = await apiClient.post("/api/register", formData, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Щось пішло не так");
  return data;
}

export async function forgotPassword(email) {
  const res = await apiClient.post("/api/forgot-password", { email }, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function resetPassword(token, newPassword) {
  const res = await apiClient.post("/api/reset-password", { token, new_password: newPassword }, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Помилка");
  return data;
}

export async function changePassword(oldPassword, newPassword) {
  const res = await apiClient.post("/api/change-password", { old_password: oldPassword, new_password: newPassword });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Помилка");
  return data;
}
